import { Pipe, type PipeTransform } from '@angular/core';
import { type GraphQLResult, isType, type OfType, type ValueOfTypename } from '../type-helpers';

@Pipe({
  name: 'isType',
})
export class IsTypePipe implements PipeTransform {
  transform<Result extends GraphQLResult, Typename extends ValueOfTypename<Result>>(
    result: Result,
    typename: Typename,
  ): result is OfType<Result, Typename> {
    return isType(result, typename);
  }
}
